// Check if value is defined, i.e. not empty or not (null | undefined)
export function isDefined<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}
